// ─── Pricing (display only — actual amounts are set on the Stripe Prices) ────
// GBP is the confirmed currency everywhere (specs/00-overview.md, "Confirmed
// decisions"). Shared by the landing page, signup plan step, and PlanPage so
// the numbers only live in one place.
// Pricing v2 (spec 30, decided 2026-10-10): Pro £2.99/mo or £24.99/yr (annual
// includes Full history), Full history £14.99 one-off. Stripe ids are SST
// secrets StripePriceIdProMonthlyV2 / StripePriceIdProAnnualV2 /
// StripePriceIdFullHistory on prod_UpeakH0MdDfAlR.

export const PRO_MONTHLY_GBP = 2.99;
export const PRO_ANNUAL_TOTAL_GBP = 24.99;
// £24.99 / 12, rounded to a displayable amount.
export const PRO_ANNUAL_PER_MONTH_GBP = 2.08;
/** Full history one-off (spec 30): lifts the 12-month cutoff and the GPX limit for good. */
export const FULL_HISTORY_GBP = 14.99;

/** Annual saving against twelve monthly payments (24.99 vs 35.88). Keep in step with the prices above. */
export const PRO_ANNUAL_SAVING_PERCENT = 30;

/**
 * Pro features at launch (spec 30), in this order. One list for the landing
 * page, the signup plan step and PlanPage. Unlimited GPX uploads is not here
 * on purpose: Full history carries it. Pro is sold as things Atlas computes,
 * never as access to Strava data (Strava Policy 5.8).
 */
export const PRO_FEATURES = [
  "Unlimited personal route checks",
  "Insights: forecasts, trends, records and visit stats",
  "Wrapped: your year in review",
  "Unlimited custom lists",
  "250 Waypoints a month",
  "Offline maps on mobile: your Atlas map without signal",
];

/** What Full history gives, for the plan cards. */
export const FULL_HISTORY_FEATURES = [
  "Atlas matches your full history, for good",
  "Every source, including ones you connect later",
  "No monthly GPX upload limit",
];

/** The line beside every Full history pay button. */
export const FULL_HISTORY_PAY_LINE = "Your full history starts matching as soon as you pay.";

/** Says plainly what monthly Pro leaves out. */
export const PRO_MONTHLY_NOTE = "Pro monthly does not include Full history.";
export const PRO_ANNUAL_NOTE = "Full history included, yours to keep even if you cancel.";
